import { render } from "./therapist.vue?vue&type=template&id=f7e5c1cc"
import script from "./therapist.vue?vue&type=script&lang=js"
export * from "./therapist.vue?vue&type=script&lang=js"

import "./therapist.vue?vue&type=style&index=0&id=f7e5c1cc&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__